// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Y4KG","label":"styles_label__3sS7i"};